import getCardHeading from '~/components/page/Automation/v2/components/Builder/utils/getCardHeading';
import type { ClientFlowAction } from '~/graphql/types.client';
import isMetadataRequiredAction from '~/typeguards/isMetadataRequiredAction';
import type { RequiresMetadataActionType } from '~/typeguards/isMetadataRequiredAction';

const getMessageForMetadataRequiringActions = ({
  branchChildren,
}: {
  branchChildren: Array<ClientFlowAction>;
}) => {
  const requiresMetadataActions = branchChildren.reduce(
    (acc, action) => {
      if (isMetadataRequiredAction(action)) {
        const key =
          action.actionType as RequiresMetadataActionType['actionType'];
        acc[key] = (acc[key] ?? 0) + 1;
      }
      return acc;
    },
    {} as Partial<Record<RequiresMetadataActionType['actionType'], number>>,
  );

  const requiresMetadataActionsCount = Object.values(
    requiresMetadataActions,
  ).reduce((acc, value) => acc + (value ?? 0), 0);

  const hasRequiresMetadataActions =
    Object.keys(requiresMetadataActions).length > 0;

  const requiresMetadataActionsText = Object.entries(requiresMetadataActions)
    .map(([actionType, actionCount]) => {
      const heading = getCardHeading(
        actionType as RequiresMetadataActionType['actionType'],
      );

      return `${actionCount}× "${heading}"`;
    })
    .join(' en ');
  const isSingleAction = requiresMetadataActionsCount === 1;

  if (!hasRequiresMetadataActions) return '';

  return `\n\nDeze branch bevat ${requiresMetadataActionsText} ${isSingleAction ? 'actie' : 'acties'}. De contacten in deze ${isSingleAction ? 'actie' : 'acties'} zullen worden verwijderd.`;
};

export default getMessageForMetadataRequiringActions;
